import React from 'react';

const Services: React.FC = () => {
  const publicUrl = process.env.PUBLIC_URL || '';
  return (
    <section id="services" className="services">
      <div className="container">
        <div className="services-header">
          <h2>Our Services</h2>
        </div>
        <div className="services-vertical">
          <div className="service-block service-block--with-image">
            <div className="service-block-image-wrapper service-block-image-wrapper--left">
              <img src={`${publicUrl}/ExerciseWarmUp.png`} alt="Clinical exercise physiology session with one-on-one coaching" className="service-block-image" />
            </div>
            <div className="service-block-main">
              <div className="service-icon-wrapper">
                <i className="fas fa-heartbeat" aria-hidden="true"></i>
              </div>
              <div className="service-content">
                <h3>Exercise Physiology</h3>
                <p>Our Clinical Exercise Physiologists combine physiotherapy with expert-led clinical exercise to treat musculoskeletal (MSK) conditions, chronic pain, injury recovery, and long-term health. We specialise in clinical, chronic, and complex conditions. Delivered in-person across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex.</p>
              </div>
            </div>
          </div>
          <div className="service-block">
            <div className="service-icon-wrapper">
              <i className="fas fa-hand-holding-heart" aria-hidden="true"></i>
            </div>
            <div className="service-content">
              <h3>Cancer Rehabilitation</h3>
              <p>Everyone's cancer journey is different, with targeted and personalised exercise this can support recovery during and after cancer treatment. Our Cancer Rehab programmes help manage fatigue, rebuild strength, and restore energy, guided by cancer exercise specialists.</p>
            </div>
          </div>
          <div className="service-block service-block--with-image">
            <div className="service-block-main">
              <div className="service-icon-wrapper">
                <i className="fas fa-microphone" aria-hidden="true"></i>
              </div>
              <div className="service-content">
                <h3>Corporate Speaking</h3>
                <p>Expert-led talks and health programmes for organisations across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex. From executive wellness to team resilience, we help professionals take control of their health.</p>
              </div>
            </div>
            <div className="service-block-image-wrapper service-block-image-wrapper--right">
              <img src={`${publicUrl}/CorporateSpeaking.jpg`} alt="PH Therapy corporate speaking and consultation" className="service-block-image" />
            </div>
          </div>
          <div className="service-block">
            <div className="service-icon-wrapper">
              <i className="fas fa-balance-scale" aria-hidden="true"></i>
            </div>
            <div className="service-content">
              <h3>Lifestyle Management</h3>
              <p>Evidence-based programmes for metabolic health, stress, and chronic disease—tailored for busy executives and professionals. We support clients with lifestyle-related conditions across London, Wimbledon, Fulham, Kensington, Chiswick, Surrey, and Sussex.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Services;
